/* ==========================================================================
   HEADER + MULTI MEGA MENU — behavior
   ========================================================================== */

(function () {
  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-mega-trigger]'));
  var closeTimers = {};
  var header = document.querySelector('[data-site-header]');
  var root = document.documentElement;

  // The mega menu uses position:fixed so it's never clipped or pushed off
  // by the theme's own containers. This keeps --hmm-top-offset in sync with
  // the header's real, current height (handles sticky shadow, font loads,
  // window resize, orientation change, etc).
  function syncTopOffset() {
    if (!header) return;
    var rect = header.getBoundingClientRect();
    root.style.setProperty('--hmm-top-offset', Math.max(rect.bottom, 0) + 'px');
  }

  syncTopOffset();
  window.addEventListener('resize', syncTopOffset);
  window.addEventListener('load', syncTopOffset);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncTopOffset);
  }

  function triggerButton(trigger) {
    return trigger.querySelector('.nav-link, .nav-all-btn');
  }

  function openTrigger(trigger) {
    syncTopOffset();
    var key = triggers.indexOf(trigger);
    clearTimeout(closeTimers[key]);
    triggers.forEach(function (t) {
      if (t !== trigger) closeTrigger(t);
    });
    trigger.classList.add('is-open');
    var btn = triggerButton(trigger);
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeTrigger(trigger) {
    trigger.classList.remove('is-open');
    var btn = triggerButton(trigger);
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    triggers.forEach(closeTrigger);
  }

  triggers.forEach(function (trigger, index) {
    trigger.addEventListener('mouseenter', function () {
      openTrigger(trigger);
    });

    trigger.addEventListener('mouseleave', function () {
      closeTimers[index] = setTimeout(function () {
        closeTrigger(trigger);
      }, 150);
    });

    var btn = triggerButton(trigger);
    if (btn) {
      btn.addEventListener('click', function (e) {
        // Touch devices: first tap opens the panel instead of following the link.
        if (window.matchMedia('(hover: none)').matches && !trigger.classList.contains('is-open')) {
          e.preventDefault();
          openTrigger(trigger);
        }
      });
    }

    // Hovering / focusing a column-1 row swaps the visible panel + image set.
    var col1Items = trigger.querySelectorAll('[data-mega-target]');
    col1Items.forEach(function (item) {
      function activate() {
        var targetId = item.getAttribute('data-mega-target');
        var panelsWrap = trigger.querySelector('.mega-menu__panels');
        if (!panelsWrap) return;

        trigger.querySelectorAll('.mega-menu__col1-item').forEach(function (i) {
          i.classList.remove('is-active');
        });
        panelsWrap.querySelectorAll('.mega-menu__panel').forEach(function (p) {
          p.classList.remove('is-active');
        });

        item.classList.add('is-active');
        var targetPanel = document.getElementById(targetId);
        if (targetPanel) targetPanel.classList.add('is-active');
      }

      item.addEventListener('mouseenter', activate);
      var link = item.querySelector('a');
      if (link) link.addEventListener('focus', activate);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mega-trigger]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      closeLocationPanel();
    }
  });

  // ---------- Location / country selector ----------
  var locationToggle = document.querySelector('[data-location-toggle]');

  function closeLocationPanel() {
    if (locationToggle) locationToggle.classList.remove('is-open');
  }

  if (locationToggle) {
    var locationBtn = locationToggle.querySelector('.site-header__location-btn');
    if (locationBtn) {
      locationBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        locationToggle.classList.toggle('is-open');
      });
      locationBtn.setAttribute('aria-expanded', 'false');
      locationToggle.addEventListener('toggle-state', function () {
        locationBtn.setAttribute('aria-expanded', locationToggle.classList.contains('is-open'));
      });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-location-toggle]')) closeLocationPanel();
    });
  }

  // ---------- Mobile drawer ----------
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileCloseEls = document.querySelectorAll('[data-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.classList.add('mobile-nav-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.classList.remove('mobile-nav-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', openMobileNav);
    mobileCloseEls.forEach(function (el) {
      el.addEventListener('click', closeMobileNav);
    });
  }

  // ---------- Sticky header shadow ----------
  if (header && header.classList.contains('is-sticky')) {
    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 4) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        syncTopOffset();
      },
      { passive: true }
    );
  }
})();
